import { getEmbeddedSDK } from '@/lib/embeddedSdk.js';
import { getEmbeddedUserToken } from '@/redux/actions/gravityActions';

export const handleOpenTestCredentials = async ({ installationId, integrationId, setLoading }) => {
  setLoading?.(true);
  try {
    const sdk = await getEmbeddedSDK();

    const expiresIn = sdk.getTokenExpiration();

    if (!expiresIn || expiresIn.getTime() - Date.now() < 60 * 1000) {
      const response = await getEmbeddedUserToken();

      if (response.token) {
        sdk.setToken(response.token);
      }
    }

    if (installationId) {
      sdk.modify({ installationId, __isInternal: true });
    } else if (integrationId) {
      sdk.install({
        integrationId,
        __isInternal: true,
        onAuthenticationComplete: () => {
          console.log('Authentication complete');
        }
      });
    }
  } catch (error) {
    console.error('Failed to open test credentials modal:', error);
  } finally {
    setLoading?.(false);
  }
};
